import { createPinia } from "pinia";
import { defineStore } from "pinia";

// 创建 Pinia 实例
const pinia = createPinia();

// 定义产品存储 store
export const useProductStore = defineStore("product", {
  state: () => ({
    products: [
      {
        id: 1,
        name: "企业管理系统 V1.0",
        cover: "https://picsum.photos/800/450?random=1",
        brief: "一站式企业数字化管理解决方案",
        price: 9999,
        detail: `
          <h3>产品亮点</h3>
          <ul>
            <li>支持多端适配（PC/移动端）</li>
            <li>模块化设计，可按需定制</li>
            <li>数据加密，保障企业信息安全</li>
          </ul>
          <h3>适用场景</h3>
          <p>中小企业人事、财务、办公一体化管理</p>
        `,
      },
      {
        id: 2,
        name: "智能数据分析平台",
        cover: "https://picsum.photos/800/450?random=2",
        brief: "基于大数据的企业决策辅助工具",
        price: 19999,
        detail: `
          <h3>产品亮点</h3>
          <ul>
            <li>实时数据可视化展示</li>
            <li>AI 辅助预测业务趋势</li>
            <li>支持自定义报表导出</li>
          </ul>
          <h3>适用场景</h3>
          <p>电商、制造、金融等行业的数据分析需求</p>
        `,
      },
      {
        id: 3,
        name: "客户关系管理系统",
        cover: "https://picsum.photos/800/450?random=3",
        brief: "提升客户转化率的全流程管理工具",
        price: 12999,
        detail: `
          <h3>产品亮点</h3>
          <ul>
            <li>客户画像自动生成</li>
            <li>销售漏斗可视化</li>
            <li>自动化客户跟进提醒</li>
          </ul>
          <h3>适用场景</h3>
          <p>销售型企业的客户管理与跟进</p>
        `,
      },
    ],
  }),
  actions: {
    getProductById(id) {
      return this.products.find((item) => item.id === Number(id));
    },
  },
});

export default pinia;
